// Where a profile photo is cropped, in fractions of the image (x and w of its width, y and h of
// its height; imgAspect = width / height):
// - the circle (unsafeMetadata.avatarCrop, chosen at upload: CropImage.vue);
// - the 167:241 rectangle of the People thumbnails (unsafeMetadata.portraitCrop, chosen on
//   #crop-portrait: CropPortrait.vue). Without one, it's estimated from the circle: the same
//   centre, as tall as the circle. A new upload clears it (it points into the old image).

export const PORTRAIT_ASPECT = 167 / 241; // width / height (People/Person.vue)

// a box of boxAspect around the circle's centre, as tall as its diameter
export function getRectFromCircle({x, y, w, imgAspect}, boxAspect) {
  const width = w * boxAspect;
  return {x: x + w / 2 - width / 2, y, w: width, h: w * imgAspect, imgAspect};
}

export function getPortraitRect(unsafeMetadata) {
  const saved = unsafeMetadata?.portraitCrop;
  if (saved?.w) return saved;
  const circle = unsafeMetadata?.avatarCrop;
  return circle?.w ? getRectFromCircle(circle, PORTRAIT_ASPECT) : null;
}

// the image's style so that rect fills a box of boxAspect (the box clips the rest)
export function getRectStyle({x, y, w, imgAspect}, boxAspect) {
  return {
    position: "absolute",
    width: `${(100 / w).toFixed(2)}%`,
    height: "auto",
    left: `${(-(x / w) * 100).toFixed(2)}%`,
    top: `${(-((y * boxAspect) / (w * imgAspect)) * 100).toFixed(2)}%`,
  };
}
